<template>
  <ReportWrapper :is-downloading="isDownloading" @download="downloadPdf" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFile } from '@/helpers/download';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';

export default defineComponent({
  name: 'ReportEmptyReturn',
  components: {
    ReportWrapper,
  },
  setup() {
    const { useDownloadEmptyUnitReport } = useReports();
    const { refetch: downloadReport, isFetching: isDownloading } = useDownloadEmptyUnitReport();
    // const { isFetching: isFetchingReport, data: reportData } = useGetEmptyUnitReport();

    const downloadPdf = async () => {
      const { data } = await downloadReport();

      if (!data) return;

      downloadFile(data.base64Data, data.filename ?? 'Unit Inventory Report');
    };

    return { downloadPdf, isDownloading };
  },
});
</script>
